'use strict';

function LessonPageResource($resource, API) {
    var urlApi = API.course + '/lessons/page';
    return $resource(urlApi, {}, {
        delete: {
            method: 'DELETE',
            url: urlApi + '/:id',
            transformResponse: function (data, headersGetter, status) {
                return {
                    status: status,
                    data: data,
                    headers: headersGetter()
                };
            }
        }
    });
}

angular
    .module('lmsApp')
    .factory('LessonPageResource', LessonPageResource);